"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RemoveSavedID_1 = require("./RemoveSavedID");
exports.default = RemoveSavedID_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/index.js
// module id = 587
// module chunks = 8